import { render, staticRenderFns } from "./mailbox-verification-outgoing-email.vue?vue&type=template&id=ab3863bc&"
import script from "./mailbox-verification-outgoing-email.vue?vue&type=script&lang=ts&"
export * from "./mailbox-verification-outgoing-email.vue?vue&type=script&lang=ts&"
import style0 from "./mailbox-verification-outgoing-email.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports